import React, { Fragment } from 'react';
import { Field } from 'formik';
import { map } from 'lodash';
import { Grid } from 'semantic-ui-react';

import HHInput from './hhInput';
import ErrorMessage from './errorMessage';

const HHList = ({
  field,
  form: { setFieldValue, touched, errors },
  otherProps
}) => {
  const hasError = !!(touched[field.name] && errors[field.name]);
  const addItem = () => {
    const newValue = ['', ...field.value];
    setFieldValue(field.name, newValue);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addItem();
    }
  };

  return (
    <Fragment>
      { map(field.value, (val, index) => (
        <Grid key={index}>
          <Grid.Column computer={13} mobile={12}>
            <Field
              name={`${field.name}[${index}]`}
              component={HHInput}
              otherProps={{ onKeyPress: handleKeyPress }}
            />
          </Grid.Column>
          <Grid.Column computer={3} mobile={4}>
            <span
              onClick={() => {
                const newValue = [...field.value];
                newValue.splice(index, 1);
                setFieldValue(field.name, newValue);
              }}
            >
              { otherProps.deleteComponent }
            </span>
          </Grid.Column>
        </Grid>
      )) }
      <span onClick={addItem}>
        { otherProps.addComponent }
      </span>
      {hasError && (<ErrorMessage error={errors[field.name]} />)}
    </Fragment>
  );
};

export default HHList;



// WEBPACK FOOTER //
// ./src/components/forms/fields/hhList.js